const colors = [
    {
        display: "Navy",
        color: "navy"
    },
    {
        display: "Red",
        color: "red"
    },
    {
        display: "Green",
        color: "green"
    },
    {
        display: "White",
        color: "white"
    },
    {
        display: "Pink",
        color: "pink"
    },
    {
        display: "Black",
        color: "black"
    },
    {
        display: "Yellow",
        color: "yellow"
    },
    {
        display: "Orange",
        color: "orange"
    },
    {
        display: "Brown",
        color: "brown"
    },
    {
        display: "Blue",
        color: "blue"
    }
]

export default colors